/* unplugin-vue-components disabled */import script from "./adv-view.vue?vue&type=script&setup=true&lang=js"
export * from "./adv-view.vue?vue&type=script&setup=true&lang=js"

import "./adv-view.vue?vue&type=style&index=0&id=d9e4ddfa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9e4ddfa"]])

export default __exports__